var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "col-xs-12 p-0" },
    [
      _c("div", { staticClass: "col-xs-12 header-wrapper" }, [
        _c(
          "div",
          {
            staticClass:
              "col-xs-12 mb-20 p-0 d-flex align-items-center justify-space-between xs-flex-column",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "page-title d-flex align-items-center col-gap-20 col-xs-12 col-sm-6 col-md-7 p-0",
              },
              [
                _c("img", {
                  staticClass: "cursor-pointer",
                  attrs: {
                    src: "/static/images/icons/chevron_left.svg",
                    alt: "download-icon",
                  },
                  on: { click: _vm.navigateToDashboard },
                }),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.headLineType === "mainheadline"
                        ? "Headlines"
                        : "Featured Content"
                    )
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "d-flex col-xs-12 align-items-center col-sm-6 col-md-5 col-gap-20 p-0",
              },
              [
                _c(
                  "div",
                  { staticClass: "search-container p-0 col-xs-10" },
                  [
                    _c("search-box", {
                      on: { getList: _vm.resetSelectedHeadlines },
                      model: {
                        value: _vm.headLineSearch,
                        callback: function ($$v) {
                          _vm.headLineSearch = $$v
                        },
                        expression: "headLineSearch",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn emergo-green-button",
                    class: {
                      "gray-out":
                        _vm.headLineType === "mainheadline"
                          ? _vm.headlinesList.length === 8
                          : _vm.headlinesList.length === 12,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.addEditHeadLine()
                      },
                    },
                  },
                  [_vm._m(0)]
                ),
                (
                  _vm.headLineType === "mainheadline"
                    ? _vm.headlinesList.length === 8
                    : _vm.headlinesList.length === 12
                )
                  ? _c(
                      "el-popover",
                      {
                        staticClass: "cursor-pointer",
                        attrs: {
                          placement: "bottom-end",
                          trigger: "click",
                          width: "350",
                        },
                        on: {
                          show: function ($event) {
                            _vm.infoActive = true
                          },
                          hide: function ($event) {
                            _vm.infoActive = false
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "limit_popover_txt" }, [
                          _vm.headLineType === "featuredcontent"
                            ? _c("span", [
                                _vm._v(
                                  " Max limit of 12 FC entries. Please delete past entries "
                                ),
                              ])
                            : _vm._e(),
                          _vm.headLineType === "mainheadline"
                            ? _c("span", [
                                _vm._v(
                                  " Max 8 main headlines can be added. Please delete and try again "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        !_vm.infoActive
                          ? _c("img", {
                              staticClass: "info-img",
                              attrs: {
                                slot: "reference",
                                src: "/static/images/icons/info_icon.svg",
                              },
                              slot: "reference",
                            })
                          : _vm._e(),
                        _vm.infoActive
                          ? _c("img", {
                              staticClass: "info-img",
                              attrs: {
                                slot: "reference",
                                src: "/static/images/icons/info_icon_active.svg",
                              },
                              slot: "reference",
                            })
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "col-xs-12 d-flex justify-space-between p-0 count-section",
          },
          [
            !_vm.isSearchByHeadLine
              ? _c(
                  "div",
                  {
                    staticClass:
                      "list-count font-18 text-secondary mb-0 fw-400",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.headlinesList.length) +
                        " " +
                        _vm._s(
                          _vm.headLineType === "mainheadline"
                            ? "Headlines"
                            : "Contents"
                        ) +
                        " "
                    ),
                  ]
                )
              : _vm.isSearchByHeadLine
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass:
                        "list-count font-18 text-secondary mb-0 fw-400",
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.filteredHeadlines.length) +
                          " result(s) found "
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "text-secondary font-16" }, [
                    _vm._v(
                      " out of " +
                        _vm._s(_vm.headlinesList.length) +
                        " " +
                        _vm._s(
                          _vm.headLineType === "mainheadline"
                            ? "Headlines"
                            : "Contents"
                        ) +
                        " "
                    ),
                  ]),
                ])
              : _vm._e(),
            _c(
              "button",
              {
                staticClass:
                  "btn btn-delete font-18 p-0 d-flex align-items-center justify-content-end col-gap-10 fw-400",
                attrs: { disabled: !_vm.selectedHeadlines.length },
                on: { click: _vm.deleteHeadLines },
              },
              [
                _c("i", { staticClass: "fa fa-trash" }),
                _vm._v(" "),
                _c("span", [_vm._v("Delete")]),
              ]
            ),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "table-responsive common-table col-xs-12 p-0" },
        [
          _c("table", { staticClass: "table" }, [
            _c("thead", [
              _c("tr", [
                _c(
                  "th",
                  {
                    staticClass: "first-col sticky",
                    staticStyle: { width: "40px" },
                  },
                  [
                    _c("span", { staticClass: "checkbox" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.isSelectAllHeadLines,
                              expression: "isSelectAllHeadLines",
                            },
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.isSelectAllHeadLines)
                              ? _vm._i(_vm.isSelectAllHeadLines, null) > -1
                              : _vm.isSelectAllHeadLines,
                          },
                          on: {
                            change: [
                              function ($event) {
                                var $$a = _vm.isSelectAllHeadLines,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.isSelectAllHeadLines = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.isSelectAllHeadLines = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.isSelectAllHeadLines = $$c
                                }
                              },
                              _vm.setSelectedHeadlines,
                            ],
                          },
                        }),
                        _c("span", { staticClass: "cr" }),
                      ]),
                    ]),
                  ]
                ),
                _c(
                  "th",
                  {
                    class: {
                      active: _vm.sortKey === "title",
                      "w-40p": _vm.headLineType === "featuredcontent",
                      "w-60p": _vm.headLineType === "mainheadline",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.sortBy("title")
                      },
                    },
                  },
                  [
                    _vm._v(" Document Name "),
                    _c("span", {
                      staticClass: "sort sortPosition",
                      class: _vm.sortOrders["title"] > 0 ? "asc" : "desc",
                    }),
                  ]
                ),
                _c("th", {
                  style: {
                    width:
                      _vm.headLineType === "featuredcontent" ? "10%" : "20%",
                  },
                }),
                _vm.headLineType === "featuredcontent"
                  ? _c(
                      "th",
                      {
                        staticClass: "text-nowrap",
                        class: { active: _vm.sortKey === "start_date" },
                        on: {
                          click: function ($event) {
                            return _vm.sortBy("start_date")
                          },
                        },
                      },
                      [
                        _vm._v(" Start Date "),
                        _c("span", {
                          staticClass: "sort sortPosition",
                          class:
                            _vm.sortOrders["start_date"] > 0 ? "asc" : "desc",
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm.headLineType === "featuredcontent"
                  ? _c(
                      "th",
                      {
                        staticClass: "text-nowrap",
                        class: { active: _vm.sortKey === "end_date" },
                        on: {
                          click: function ($event) {
                            return _vm.sortBy("end_date")
                          },
                        },
                      },
                      [
                        _vm._v(" End Date "),
                        _c("span", {
                          staticClass: "sort sortPosition",
                          class:
                            _vm.sortOrders["end_date"] > 0 ? "asc" : "desc",
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm.headLineType === "mainheadline"
                  ? _c(
                      "th",
                      {
                        staticClass: "text-nowrap",
                        class: { active: _vm.sortKey === "display_date" },
                        on: {
                          click: function ($event) {
                            return _vm.sortBy("display_date")
                          },
                        },
                      },
                      [
                        _vm._v(" Created Date "),
                        _c("span", {
                          staticClass: "sort sortPosition",
                          class:
                            _vm.sortOrders["display_date"] > 0 ? "asc" : "desc",
                        }),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
            _c(
              "tbody",
              { ref: "tbodyBox" },
              _vm._l(_vm.filteredHeadlines, function (headline) {
                return _c(
                  "tr",
                  {
                    key: headline.id,
                    staticClass: "cursor-pointer",
                    class: {
                      "row-active": _vm.selectedHeadlines.includes(headline.id),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.addEditHeadLine("edit", headline)
                      },
                    },
                  },
                  [
                    _c(
                      "td",
                      {
                        staticClass: "first-col sticky",
                        staticStyle: { width: "40px" },
                      },
                      [
                        _c("span", { staticClass: "checkbox" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.isSelectAllHeadLines,
                                  expression: "isSelectAllHeadLines",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.isSelectAllHeadLines)
                                  ? _vm._i(_vm.isSelectAllHeadLines, null) > -1
                                  : _vm.isSelectAllHeadLines,
                              },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$a = _vm.isSelectAllHeadLines,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.isSelectAllHeadLines =
                                            $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.isSelectAllHeadLines = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.isSelectAllHeadLines = $$c
                                    }
                                  },
                                  _vm.setSelectedHeadlines,
                                ],
                              },
                            }),
                            _c("span", { staticClass: "cr" }),
                          ]),
                        ]),
                      ]
                    ),
                    _c("td", [_vm._v(" " + _vm._s(headline.title) + " ")]),
                    _c("td"),
                    _vm.headLineType === "featuredcontent"
                      ? _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("dateFormat")(headline.start_date)
                              ) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                    _vm.headLineType === "featuredcontent"
                      ? _c("td", [
                          _vm._v(
                            _vm._s(_vm._f("dateFormat")(headline.end_date))
                          ),
                        ])
                      : _vm._e(),
                    _vm.headLineType === "mainheadline"
                      ? _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("dateFormat")(headline.display_date)
                              ) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm.filteredHeadlines.length == 0 && !_vm.loaderStatus
            ? _c("div", { staticClass: "no-records-found" }, [
                _vm._v(" No Records Found "),
              ])
            : _vm._e(),
        ]
      ),
      _c("delete-headline-popup", {
        attrs: {
          selectedHeadlines: _vm.selectedHeadlines,
          headLineType: _vm.headLineType,
        },
        on: { refreshHeadLinesList: _vm.fetchNewList },
      }),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("img", {
        attrs: { src: "/static/images/icons/add.svg", alt: "add-icon" },
      }),
      _c("span", { staticClass: "pl-5 xs-hide" }, [_vm._v("Add")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }